import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapPin } from "lucide-react";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
});

const delivererIcon = L.divIcon({
  className: "custom-marker",
  html: `<div style="background:#10b981;width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:3px solid white;box-shadow:0 3px 12px rgba(0,0,0,0.3);font-size:20px;animation:pulse 2s infinite;">&#x1F3CD;</div>`,
  iconSize: [44, 44],
  iconAnchor: [22, 22],
});

const restaurantIcon = L.divIcon({
  className: "custom-marker",
  html: `<div style="background:#ef4444;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.3);font-size:18px;">&#x1F3EA;</div>`,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});

export default function TrackingMap({ tracking, restaurantPos, tt }) {
  const loc = tracking.deliverer_location;
  const center = loc ? [loc.lat, loc.lng] : restaurantPos;

  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden" data-testid="tracking-map">
      <div className="px-5 py-3 border-b flex items-center justify-between">
        <h3 className="font-bold text-gray-900 flex items-center gap-2">
          <MapPin className="w-4 h-4 text-emerald-600" /> {tt("liveTracking")}
        </h3>
        <div className="flex items-center gap-1 text-xs text-emerald-600">
          <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
          {tt("realtime")}
        </div>
      </div>
      <div className="h-[300px]">
        <MapContainer center={center} zoom={15} className="h-full w-full" zoomControl={false}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker position={restaurantPos} icon={restaurantIcon}>
            <Popup>{tracking.restaurant_name}</Popup>
          </Marker>
          {loc && (
            <Marker position={[loc.lat, loc.lng]} icon={delivererIcon}>
              <Popup>
                <strong>{tracking.deliverer_name}</strong><br />{tt("yourDriver")}
              </Popup>
            </Marker>
          )}
          {loc && (
            <Polyline
              positions={[restaurantPos, [loc.lat, loc.lng]]}
              pathOptions={{ color: "#10b981", weight: 3, dashArray: "10, 10" }}
            />
          )}
        </MapContainer>
      </div>
    </div>
  );
}
